import React from 'react';
import { MasterLayout } from 'layout';
import { browserHistory } from 'react-router';
import { HandleLetters } from 'modules/handle-letters';
import cookie from 'react-cookie';
import { checkServerLive } from 'constants/config';
import { Danhmuc } from 'api';

export default class HandleLettersPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataThamSo: []
    }
  }

  componentWillMount() {
    if (typeof cookie.load('accessToken') === 'undefined') {
      browserHistory.push('/dang-nhap');
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <HandleLetters param={this.props.params} />
      </MasterLayout>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/handle-letters/HandleLettersPage.jsx